import { action as apiAction } from 'api/Api'

type Payload = {
  messageId: number
}

const requestRemoveMessage = (payload: Payload) => async () => {
  const { messageId } = payload

  await apiAction('RemoveCommentFromCard', {
    notificationId: messageId
  })
}

export default requestRemoveMessage